<template>
  <div class="container">
    <div class="content-container">
      <answer-progress
        v-if="quizData.questions"
        :current="currentQuizIndex + 1"
        :length="quizData.questions.length"
      />
      <div v-if="quizData.questions && quizData.questions.length > 0" class="quiz-title">
        {{ quizData.questions[currentQuizIndex].title }}
      </div>
      <!-- </div> -->
      <option-group
        v-if="quizData.questions && quizData.questions.length > 0"
        :options="quizData.questions[currentQuizIndex].options"
        :selectingOption="this.selectingOption"
        :onOptionSelect="this.onOptionSelect"
      ></option-group>

      <div class="button-group-option">
        <van-button
          v-if="currentQuizIndex > 0"
          style="width: 42%"
          size="small"
          round
          plain
          type="info"
          color="#3994E7"
          @click="privQuestion()"
          >上一题</van-button>
        <div style="flex:1"/>
        <van-button
          v-if="quizData.questions && currentQuizIndex < this.quizData.questions.length - 1"
          style="width: 42%"
          size="small"
          round
          plain
          type="info"
          color="#3994E7"
          @click="nextQuestion()"
          >下一题</van-button
        >
      </div>
    </div>

    <answer-footer
      :active="activeFooter"
      text="提交答案"
      :onItemClick="this.onFooterClick"
      :onButtonClick="this.submitAnswer"
    />
    <article-review-modal
      v-if="activeFooter == ANSWER_FOOTER_TYPE.ARTICLE_REVIEW"
      v-show="activeFooter == ANSWER_FOOTER_TYPE.ARTICLE_REVIEW"
      :onClose="this.onModalClose"
    />
    <quiz-list-modal
      v-if="activeFooter == ANSWER_FOOTER_TYPE.QUIZ_LIST"
      v-show="activeFooter == ANSWER_FOOTER_TYPE.QUIZ_LIST"
      :onClose="this.onModalClose"
      :onQuizSelect="this.onQuizSelect"
    />
    
  </div>
</template>
<script>
import AnswerFooter from "../../components/footer/AnswerFooter";
import ArticleReviewModal from "./component/ArticleReviewModal";
import QuizListModal from "./component/QuizListModal";
import { ANSWER_FOOTER_TYPE } from "../../contants/article";
import AnswerProgress from "./component/AnswerProgress";
import OptionGroup from "./component/OptionGroup";
import _ from "lodash";
import { Toast } from "vant";
import {postAnswers} from "@/api/article"
import {mapState} from "vuex"
import moment from 'moment';
import * as ActionTypes from "@/store/action-types"

export default {
  name: "AnswerPage",
  data() {
    return {
      ANSWER_FOOTER_TYPE: ANSWER_FOOTER_TYPE,
      FOOTER_ITEMS: [
        {
          label: "当前难度",
          type: ANSWER_FOOTER_TYPE.LEVEL,
        },
        {
          label: "文章导读",
          type: ANSWER_FOOTER_TYPE.ARTICLE_REVIEW,
        },
        {
          label: "生词本",
          type: ANSWER_FOOTER_TYPE.QUIZ_LIST,
        },
      ],
      activeFooter: 0,
      articleLevel: { name: "150L", desc: "适合：小升初、pet预备" },
      // selectLevel: { name: "150L", desc: "适合：小升初、pet预备" },
      // quizData: {},
      // answer: [],
      currentQuizIndex: 0,
      selectingOption: 0,
     
    };
  },

  components: {
    AnswerFooter,
    AnswerProgress,
    OptionGroup,
    ArticleReviewModal,
    QuizListModal,
  },
  computed: {
    ...mapState({
      contentId: (state) => state.article.contentId,
      startTime: (state) => state.article.startTime,
      answer: (state) => state.article.answer,
      quizData: (state) => state.article.quizData
    }),
  },
  mounted() {
    console.log("==========>");
  },
  activated() {
    this.currentQuizIndex = 0;
    this.$store.dispatch(ActionTypes.GET_ARTICLE_QUIZ)
  },
  watch: {
    currentQuizIndex(val) {
      this.selectingOption = _.get(this.answer[val], "optionId", 0);
    },
  },
  methods: {
    onBack() {
      this.$router.back(-1)
      // location.href = "/home";
    },
    onFooterClick(footerType) {
      console.log("onFooterClick = ", footerType);
      if (footerType == ANSWER_FOOTER_TYPE.LEVEL) {
        Toast("答题过程中不能修改文章难度");
      } else {
        this.activeFooter = footerType;
      }
    },

    onOptionSelect(optionId) {

      const question = this.quizData.questions[this.currentQuizIndex];
      let newAnswer = this.answer
      newAnswer[this.currentQuizIndex] = {
        questionId: question.questionId,
        optionId: optionId,
      }
      this.$store.dispatch(ActionTypes.UPDATE_ARTICLE_ANSWER,newAnswer)
      this.selectingOption = optionId;
    },
    nextQuestion() {
      this.currentQuizIndex += 1;
    },
    privQuestion() {
      this.currentQuizIndex -= 1;
    },
    onQuizSelect(index) {
      this.currentQuizIndex = index;
      this.activeFooter = 0;
    },
    submitAnswer() {
      let isComplete = true;
      console.log("aaa", moment().valueOf());
      _.map(this.answer, (item) => {
        if (_.get(item, "optionId", 0) < 1) {
          isComplete = false;
        }
      });
      if (!isComplete) {
        Toast("请完成所有题目再提交答案");
        return;
      }

    let reqData = {
      contentId : this.contentId,
      duration: moment().valueOf() - this.startTime,
      answers : this.answer
      
    }
    postAnswers(reqData).then(result=>{
      this.$store.dispatch(ActionTypes.SET_ARTICLE_RESULT,result.data)
      console.log('=>>>>>>>>>',result)
      this.$router.push({path:'/answerResultPage'})
    })

    },
    onModalClose() {
      this.activeFooter = 0;
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container {
  min-height: 100vh;
  padding-bottom: 50px;
  background: #ffffff;
}

.quiz-title {
  font-size: 14px;
  color: #333333;
}

.guide-container {
  padding: 15px;
  background: #ffffff;
}

.article-content-snapshot {
  padding-bottom: 10px;
  font-size: 14px;
}

.article-content-title {
  font-size: 18px;
  color: #333333;
  font-family: serif,SimSun,STSong;
  margin: 5px 0;
}

.content-container {
  flex: 1;
  display flex;
  flex-direction : column;
  padding: 15px;
  background: #ffffff;
  overflow: scroll;
}

.button-group-option {
  display: flex;
  width: 100%;
  flex-direction :row;
  // justify-content: space-between;
  // flex-flow: row wrap;
}
</style>


// WEBPACK FOOTER //
// app/pages/article/AnswerPage.vue